module.exports = __webpack_public_path__ + "static/media/badge_executivo.d9a97120.svg";